import { useContext } from "react";
import { useNotesRecords } from "../../api/useNotesRecords";
import { RecordContext } from "../record/Record";

export const useNotes = (extraEntities?: Array<string>, categoryFilter?: Record<string, any>) => {
	const recordContext = useContext(RecordContext);

	const extraFilter =
		(recordContext?.id && extraEntities && createExtraNotesFilter(extraEntities, recordContext.id)) || [];

	const entityFilter = {
		_or: [
			recordContext && { [recordContext.entity]: { id: { _eq: recordContext?.id } } },
			...extraFilter,
		].filter(Boolean),
	};

	const notesFilter = categoryFilter
		? { _and: [entityFilter, categoryFilter] }
		: entityFilter;

	const { data, status } = useNotesRecords({ fields: "*,user_created.avatar", filter: notesFilter });

	const notes = data ?? [];

	return { notes, notesStatus: status };
};

const createExtraNotesFilter = (extraEntities: Array<string>, mainEntityId: string | number) => {
	return extraEntities.map((entity) => ({
		[entity]: { client: { id: { _eq: mainEntityId } } },
	}));
};
